import { type Dispatch, type SetStateAction } from "react";

export const createTextInputHandler = (onChange: Dispatch<SetStateAction<string>>) => {
    return (value: string): void => {
        if (!value.startsWith(" ")) {
            onChange(value);
        }
    };
};
